module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "demo-table-approve-row"
    }
  }, [_c('hrms-table', {
    attrs: {
      "columns": _vm.columns[_vm.nowLang].index,
      "data": _vm.index,
      "indexDisp": true,
      "approveDisp": true,
      "approveBtnDisp": true,
      "approveRowBool": true,
      "approveEvent": _vm.approveEvent,
      "detailEvent": _vm.detailEvent,
      "nowLang": _vm.nowLang
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3b13d763!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/demoTableApproveRow.vue
// module id = 3696
// module chunks = 1